import { Box, Container } from "@mui/material";

import DownloadApp from "@/components/DownloadApp/DownloadApp";
import Road from "./components/Road";
import useResponsive from "@/hooks/useResponsive";
import { containerStyles } from "./styles";

const Download = () => {
  const isDesktop = useResponsive("up", "md");

  return (
    <Box component="section" pt={{ xs: 5, md: 0 }} pb={{ xs: 5, md: 0 }}>
      <Container sx={containerStyles}>
        {isDesktop && <Road />}
        <DownloadApp />
      </Container>
    </Box>
  );
};

export default Download;
